<template>
  <div class="page-wrapper">
    <div class="container">
      <!-- content -->
      <div class="content">
        <div class="row">
          <div class="col-md-12">
            <!-- search-content -->
            <div class="container search-content">
              <h2>Search for College Events</h2>
            </div>
            <div
              class="dynamic-search-container-college-event dynamic-search-container-college"
            >
              <div class="mobile-filter">
                <div class="filter-button" @click="showDrawer">
                  <a-icon type="filter" />
                  Filter Table
                </div>
                <a-drawer
                  class="filter-modal menu-modal custom-modal"
                  placement="right"
                  :visible="visible"
                  @close="onClose"
                >
                  <div class="filter-title">
                    Filter College Events
                  </div>
                  <BaseFilter
                    class="collapse in"
                    :items="allColleges"
                    :config="searchConfig"
                    @submit="handleFilterApply"
                    @on-filter-change="handleFilterChange"
                  />
                </a-drawer>
              </div>
              <BaseFilter
                :items="allColleges"
                class="collapse in"
                :config="searchConfig"
                @submit="handleFilterApply"
                @on-filter-change="handleFilterChange"
              />
            </div>
            <div class="">
              <BaseTable
                :data="collegeEvents"
                :columns="columns"
                :pagination="paginationOptions"
                :loading="collegeEventsLoading"
                @change="handleTableChange"
                :show-zero="collegeEventsMeta.total === 0"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CollegeEvent } from "@/models";
import { mapGetters } from "vuex";
import { SEARCH_COLLEGE_EVENT_INDEX_TABLE } from "@/utils/columns";

const COLLEGE_EVENT_STORE_KEY = "collegeEventStore";
const FAVOURITE_STORE_KEY = "favouriteStore";
const COLLEGE_STORE_KEY = "collegeStore";

const FIELDS = "id, collegeName";

export default {
  data() {
    return {
      searchConfig: CollegeEvent.searchConfig,
      currentPage: 1,
      visible: false,
      fields: "title, eventType, date, location, division, time, collegeName",
      searchQuery: {}
    };
  },
  mounted() {
    this.dispatcher();
    this.getAllColleges();
  },
  computed: {
    columns() {
      return [
        {
          title: "Fav",
          dataIndex: "favourite",
          customRender: (_text, rowData, _index) => {
            const h = this.$createElement;
            const className = rowData.favC ? "icon-filled" : "";
            const iconTheme = rowData.favC ? "filled" : "outlined";
            return (
              <BaseButton
                type="link"
                size="large"
                class={className}
                on-click={event => this.handleFavouriteClick(event, rowData)}
              >
                <BaseIcon type="star" theme={iconTheme} />
              </BaseButton>
            );
          }
        },
        {
          title: "College Name",
          dataIndex: "collegeName",
          customRender: (_text, rowData) => {
            const h = this.$createElement;
            return (
              <a
                class="bold-color-blue"
                href={this.linkToCollege(rowData.collegeId._id)}
              >
                {rowData.collegeId.collegeName}
              </a>
            );
          }
        },
        {
          title: "Event Name",
          dataIndex: "title",
          customRender: (_text, rowData) => {
            const h = this.$createElement;
            return (
              <a
                href={this.linkToCollegeEvent(
                  rowData.id,
                  rowData.collegeId._id
                )}
                class="bold-color-blue"
              >
                {rowData.title}
              </a>
            );
          }
        },
        ...SEARCH_COLLEGE_EVENT_INDEX_TABLE
      ];
    },
    currentDate() {
      const currentDate = new Date();
      const month = `0${currentDate.getMonth() + 1}`;
      return `${currentDate.getFullYear()}/${
        month.length === 2
          ? month
          : `${month.split("")[1]}${month.split("")[2]}`
      }/${currentDate.getDate()}`;
    },
    ...mapGetters({
      collegeEvents: `${COLLEGE_EVENT_STORE_KEY}/collegeEvents`,
      collegeEventsLoading: `${COLLEGE_EVENT_STORE_KEY}/collegeEventsLoading`,
      collegeEventsMeta: `${COLLEGE_EVENT_STORE_KEY}/collegeEventsMeta`,
      allColleges: `${COLLEGE_STORE_KEY}/allColleges`
    }),
    paginationOptions() {
      return {
        total: this.collegeEventsMeta.total || 40,
        current: this.currentPage || 1,
        simple: true
      };
    }
  },
  methods: {
    dispatcher(page = 1) {
      this.currentPage = page;
      this.$store.dispatch(`${COLLEGE_EVENT_STORE_KEY}/getCollegeEvents`, {
        fields: this.fields,
        page: page,
        limit: 10,
        ...this.searchQuery,
        "date[gte]": this.searchQuery["date"] ? null : this.currentDate
      });
    },
    async getAllColleges() {
      this.$store.dispatch(`${COLLEGE_STORE_KEY}/getAllColleges`, {
        fields: FIELDS,
        sort: "collegeName",
        limit:40,
      });
    },

    async handleFavourite(rowData){
      if (rowData.favC) {
        await this.$store.dispatch(`${FAVOURITE_STORE_KEY}/deleteFavourite`, {
          favBy: CollegeEvent.profileId(),
          favTo: rowData.Id
        });
        this.$store.dispatch(
          `${COLLEGE_EVENT_STORE_KEY}/unsetFavourite`,
          rowData.Id
        );
        return;
      }
      await this.$store.dispatch(`${FAVOURITE_STORE_KEY}/createFavourite`, {
        favBy: CollegeEvent.profileId(),
        favTo: rowData.Id,
        typeFav: "collegeEvent"
      });
      this.$store.dispatch(
        `${COLLEGE_EVENT_STORE_KEY}/setFavourite`,
        rowData.Id
      );
    },
    async handleFavouriteClick(event, rowData) {
      event.stopImmediatePropagation();
      const local_profile_id = localStorage.getItem("profile-id");
      const route_profile_id = this.$route.params.profileId;
      const currentUser = localStorage.getItem("user-permissions");
      if(currentUser === '"player"'){
        this.handleFavourite(rowData);
      }else{
        if(local_profile_id === route_profile_id){
          this.handleFavourite(rowData);
        }else{
           this.$notification.error({
              message: "Error",
              description:"Favourite Error"
            });
        }
      }
    },

    handleFilterChange(searchQuery) {
      this.searchQuery = searchQuery;
    },
    handleFilterApply() {
      this.dispatcher();
      this.visible = false;
    },
    handleTableChange(pagination) {
      this.dispatcher(pagination.current);
    },

    showDrawer() {
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    handleOk(e) {
      this.visible = false;
    },
    linkToCollege(id) {
      return `/${this.$route.params.profileId}/college_profile/${id}/summary`;
    },
    linkToCollegeEvent(id, collegeId) {
      return `/${this.$route.params.profileId}/college/${collegeId}/event/${id}`;
    }
  }
};
</script>

<style lang="sass">
.ant-select-dropdown-menu-item
  text-transform: capitalize
.dynamic-search-container-college-event
  form
    display: grid
    grid-template-columns: repeat(auto-fill, 13.55rem)
    margin-bottom: 10px
    input
      width: 98%
    .ant-select-selection
      width: 98%
    .ant-form-item
      width: 98%
    .ant-time-picker
      width: 98%
    .ant-calendar-picker
      .ant-calendar-picker-icon
        right: 20px
    @media (min-width: 767px)
      .grid-component-wrapper-one
        grid-column-start: 1
        grid-column-end: 2
        width: 100%
      .grid-component-wrapper-two
        grid-column-start: 2
        grid-column-end: 3
        grid-row-start: 1
      .grid-component-wrapper-three
        grid-column-start: 3
        grid-column-end: 4
        grid-row-start: 1
      .grid-component-wrapper-five
        grid-column-start: 4
        grid-column-end: 5
        grid-row-start: 1
      .grid-component-wrapper-six
        grid-column-start: 5;
        grid-column-end: 6
        grid-row-start: 1
      .grid-component-wrapper-seven
        grid-column-start: 2
        grid-column-end: 3
      .grid-component-wrapper-eight
        grid-column-start: 3
        grid-column-end: 4
      .grid-component-wrapper-eleven
        grid-column-start: 3
        grid-column-end: 4
        grid-row-start: 3
        margin-top: 5px
</style>
